'use client'
const isString = (arg) => typeof arg === 'string';

export { isString };
